import * as Router from "vue-router";
// import Index from '@/page/Index'
import Home from "../pages/Home";
import Cases from "../pages/Cases";
import SolutionPage from "../pages/SolutionPage";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  // {
  //   path: '/index',
  //   name: 'Index',
  //   component: Index
  // },
  {
    path: "/cases",
    name: "Cases",
    component: Cases,
  },
  {
    path: "/solution",
    name: "SolutionPage",
    component: SolutionPage,
  },
];

const router = Router.createRouter({
  history: Router.createWebHistory(),
  scrollBehavior: function (to, from, savedPosition) {
    from;
    savedPosition;
    if (savedPosition) {
      return savedPosition;
    } else if (to.hash) {
      return { el: to.hash, top:-10, behavior: "smooth" };
    } else {
      return { left: 0, top: 0 };
    }
  },
  routes,
});

export default router;
